import type { Slide } from '@features/powerpoint';
import type { BuildPresentationProps } from '../build-presentation';
import { executiveSummarySlideV2 } from '../../../../slides/executive-summary-slide-v2';
import { NEWLINE_REGEX } from '../../../../domain/key-takeaways';

export const executiveSummarySlideFromPropsV2 = (
  props: BuildPresentationProps,
  slideMaster: string
): Slide[] =>
  props.customFields.includedSlides.overall.executiveSummary
    ? [
        executiveSummarySlideV2({
          slideMaster,
          rsaKeyTakeaways: props.customFields.rsaSummary.split(NEWLINE_REGEX),
          ftaKeyTakeaways: props.report.hasVisitMetrics
            ? props.customFields.ftaSummary.split(NEWLINE_REGEX)
            : [''],
        }),
      ]
    : [];
